<div class="page-container" animate.enter="route-slide-in-right" animate.leave="route-slide-out-right">
  <div class="page-title-row flex flex-align-center gap-sm mb-md">
    <app-back-button [ariaLabel]="'settings.back' | translate" />
    <h2>{{ 'settings.general.title' | translate }}</h2>
  </div>

  <app-card>
    <app-card-content>
      <!-- Leaderboard -->
      <div class="settings-section">
        <div class="setting-item">
          <div class="setting-header">
            <h4>{{ 'settings.leaderboard.title' | translate }}</h4>
            <app-checkbox [(ngModel)]="leaderboardEnabledValue" (ngModelChange)="toggleLeaderboardEnabled()"
              data-testid="leaderboard-enabled-toggle" />
          </div>
          <p class="setting-description">{{ 'settings.leaderboard.description' | translate }}</p>
        </div>
      </div>

      <!-- Geocoding provider -->
      <div class="settings-section">
        <div class="setting-item">
          <div class="setting-info">
            <h4>{{ 'settings.geocoding.title' | translate }}</h4>
            <p class="setting-description">{{ 'settings.geocoding.description' | translate }}</p>
          </div>
          <app-select data-testid="geocoding-provider-select">
            <select [(ngModel)]="geocodingProviderValue" (ngModelChange)="onGeocodingProviderChange()"
              class="form-control">
              @for (option of geocodingProviderOptions; track option.value) {
              <option [value]="option.value">{{ option.label | translate }}</option>
              }
            </select>
          </app-select>
        </div>
      </div>

      <!-- Camera -->
      <div class="settings-section">
        <h3>{{ 'settings.camera.title' | translate }}</h3>

        <div class="setting-item">
          <div class="setting-info">
            <h4>{{ 'settings.camera.cameraTimeout.title' | translate }}</h4>
            <p class="setting-description">
              {{ 'settings.camera.cameraTimeout.description' | translate }}
            </p>
          </div>
          <div class="timeout-input-group">
            <app-input>
              <input type="number" [(ngModel)]="cameraTimeoutValue" (ngModelChange)="onCameraTimeoutChange($event)"
                min="5" max="180" step="5" data-testid="camera-timeout-input" />
            </app-input>
            <span class="timeout-unit">{{ 'settings.camera.cameraTimeout.seconds' | translate }}</span>
          </div>
        </div>
      </div>

      <!-- Demo Mode -->
      @if (canOverrideArtwork) {
      <div class="settings-section">
        <h3>{{ 'settings.demoMode.title' | translate }}</h3>
        <p class="section-description muted">
          {{ 'settings.demoMode.description' | translate }}
        </p>

        <div class="setting-item">
          <div class="setting-info">
            <h4>{{ 'settings.demoMode.autoReset.title' | translate }}</h4>
            <p class="setting-description">
              {{ 'settings.demoMode.autoReset.description' | translate }}
            </p>
          </div>
          <input type="number" class="form-control" [(ngModel)]="expiryMinutes"
            [min]="environmentService.getMinExpiryMinutes()" [max]="environmentService.getMaxExpiryMinutes()"
            [step]="15" data-testid="expiry-minutes-input" />
        </div>

        <div class="setting-item">
          <div class="setting-info">
            <h4>{{ 'settings.demoMode.artwork.title' | translate }}</h4>
            <p class="setting-description">
              {{ 'settings.demoMode.artwork.description' | translate:{ currentEnvironment: currentEnvironment } }}
              @if (overrideExpiresAt) {
              <span class="expiry-notice">
                {{ 'settings.demoMode.artwork.overrideExpiry' | translate:{ expiresAt: ((overrideExpiresAt |
                date:'short') ?? '') } }}
              </span>
              }
            </p>
          </div>
          <app-select data-testid="artwork-env-select">
            <select [(ngModel)]="selectedArtworkEnv" (ngModelChange)="onArtworkEnvChange($event)" class="form-control">
              @for (option of artworkEnvironmentOptions; track option.value) {
              <option [value]="option.value">{{ option.label }}</option>
              }
            </select>
          </app-select>
        </div>
      </div>
      }

      <!-- Map coverage layer display -->
      @if (canManageMapDisplay) {
      <div class="settings-section" data-testid="map-display-settings-section">
        <h3>{{ 'settings.mapDisplay.title' | translate }}</h3>
        <p class="section-description muted">{{ 'settings.mapDisplay.description' | translate }}</p>
        <form [formGroup]="mapDisplayForm">
          <formly-form
            [form]="mapDisplayForm"
            [fields]="mapDisplayFields"
            [model]="mapDisplayModel"
            (modelChange)="onMapDisplayModelChange($event)"
          />
        </form>
      </div>
      }

      <!-- Feature Flags -->
      <div class="settings-section">
        <h3>{{ 'settings.featureFlags.title' | translate }}</h3>
        <p class="section-description muted">{{ 'settings.featureFlags.comingSoon' | translate }}</p>
      </div>
    </app-card-content>
  </app-card>
</div>
